// Имя параметра локали в URL.
export const LANG_PARAM_NAME = 'lang' as const;
